import type { LibraryFormats } from 'vite';

export const DEFAULT_OUT_DIR = './dist';
export const DEFAULT_ENTRY = './src/index.ts';
export const DEFAULT_EXPORT_FORMATS: LibraryFormats[] = ['es', 'cjs'];
export const DEFAULT_BUILD_TARGET = 'es2020';
